import _ from 'lodash';

export const fullName = (personalDetails, opts = {}) => {
  const { withPrefix = false } = opts;
  const nameObj = [
    personalDetails?.firstName,
    personalDetails?.middleName,
    personalDetails?.lastName,
  ];
  if (withPrefix) nameObj.unshift(personalDetails?.prefix);

  return _.compact(nameObj).join(' ');
};

export const getFileNameFromUrl = (url = '') => {
  return decodeURI(
    _.replace(url, /%2F/g, '/')
      .split('/')
      .pop()
      .substring(_.replace(url, /%2F/g, '/').split('/').pop().indexOf('-') + 1),
  );
};

// eslint-disable-next-line import/prefer-default-export
export const formatForDropdown = (
  items = [],
  labelField = 'label',
  valueField = 'value',
  includeItem = false,
  additionalLabelField = '',
) => {
  return items.map((item) => {
    const dropdownItem = {
      label: item[labelField],
      value: item[valueField],
    };

    if (includeItem) {
      dropdownItem.item = item;
    }
    if (_.get(item, additionalLabelField)) {
      dropdownItem.label += ` - ${_.get(item, additionalLabelField)}`;
    }
    return dropdownItem;
  });
};

export const formatForDropdownCallers = (
  items = [],
  labelField1 = 'label',
  labelField2 = 'label',
  labelField3 = 'label',
  valueField = 'value',
  includeItem = false,
  additionalLabelField = '',
) => {
  return items.map((item) => {
    const dropdownItem = {
      label: `${item[labelField1]} ${item[labelField2]} ${item[labelField3]}`,
      value: item[valueField],
    };

    if (includeItem) {
      dropdownItem.item = item;
    }
    if (_.get(item, additionalLabelField)) {
      dropdownItem.label += ` - ${_.get(item, additionalLabelField)}`;
    }
    return dropdownItem;
  });
};

export const scrollToTop = () => {
  return window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const fileSizeInMB = (sizeInBytes) => (sizeInBytes / (1024 * 1024)).toFixed(2);

export const parseQuery = (search = '') => {
  const queryString = search.includes('?') ? search.split('?')[1] : search;
  const params = new URLSearchParams(queryString);

  return Array.from(params.entries()).reduce((acc, [key, value]) => {
    if (Object.hasOwn(acc, key)) {
      acc[key] = Array.isArray(acc[key]) ? [...acc[key], value] : [acc[key], value];
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
};

// price format - $1,000,000.00
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export const getPrice = (price) => {
  let dollarPrice = '0.00';
  if (price || price === 0) {
    dollarPrice = `${Math.abs(price)}`;
    if (price < 0) {
      dollarPrice = `-${dollarPrice}`;
    }
  }
  return formatter.format(dollarPrice);
};

export const fileTypeCheckFactory = (types) => (file) => types.includes(file.type.split('/')[1]);

export const fileExtensionCheckFactory = (types) => (file) =>
  types.includes(file.name.split('.').pop().toLowerCase());

export const fileMaxCheckFactory = (maxSize) => (file) => fileSizeInMB(file.size) <= maxSize;

/* This function helps to check the validation of field that have type "number".If it is bad input it sets to null. */
export const amountChecker = (event, setFieldValue, fieldName, fieldValue) => {
  if (!event.target.validity.badInput) {
    setFieldValue(fieldName, event.target.value);
  } else {
    setFieldValue(fieldName, fieldValue || '');
  }
};

/* This function doesnt accept any '+' or '-' while giving input of type "number" */
export const keyPress = (event, setFieldValue, fieldName, fieldValue) => {
  if (['-', '+'].includes(event.key)) {
    if (!fieldValue) {
      setFieldValue(fieldName, ' ');
    }
  }
};

export const formatterForDropdownObject = (
  data,
  valueName = 'value',
  labelName = 'label',
  additionalLabelField = '',
) => {
  if (data) {
    const obj = { ...data };
    obj.value = _.get(data, valueName);
    delete obj[valueName];
    obj.label = _.get(data, labelName);
    delete obj[labelName];
    if (_.get(data, additionalLabelField)) {
      obj.label += ` - ${_.get(data, additionalLabelField)}`;
    }
    return obj;
  }
  return '';
};

// to fix the scrolling issue on windows
export const removeMultiselectTabIndexes = () => {
  const multiSelects = document.getElementsByClassName('multi-select');

  Array.from(multiSelects).forEach((el) => {
    el.getElementsByClassName('dropdown')[0].removeAttribute('tabindex');
  });
};
